module.exports = __webpack_public_path__ + "img/winner.fcfa230a.png";